import React from 'react';
import Countdown from '../components/Header/Countdown';

const getOpenEnrollmentDates = function () {
  let currentDate = new Date();

  let openEnrollmentStartDate = new Date('10/15/2024');
  let openEnrollmentCountdownStart = new Date('12/01/2024');
  let openEnrollmentEndDate = new Date('12/07/2024');

  if (currentDate > openEnrollmentStartDate && currentDate < openEnrollmentCountdownStart) {
    return (<div className='topBanner withCountdown'><span className='copy'>Open Enrollment is underway! If you&rsquo;re eligible for Medicare, you have until Dec 7 to get coverage for 2025.</span></div>);
  } else if (currentDate > openEnrollmentCountdownStart && currentDate < openEnrollmentEndDate) {
    return (<div className='topBanner withCountdown'><span className='copy'>Open Enrollment is underway! If you&rsquo;re eligible for Medicare, you have</span> <Countdown date='2024-12-07T23:59:59' /> <span className='copy'>left to get coverage for 2025.</span></div>);
  } else {
    return false;
    // return (<div className='topBanner'>CDPHP Medicare HMO and PPO plans rated 5 stars by the Centers for Medicare &amp; Medicaid Services for 2023. Enroll any time before November 30th.</div>);
  }
};
export default getOpenEnrollmentDates;


// WEBPACK FOOTER //
// ./src/helpers/openEnrollment.js